import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CapitalizePipe } from './utility/pipe/capitalize.pipe';
import { HttpClient, HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { authenticationInterceptor } from './utility/interceptor/authentication.interceptor';
import { loaderInterceptor } from './utility/interceptor/loader.interceptor';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { NavbarComponent } from './navbar/navbar.component';
import { SharedModule } from './utility/shared/shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';

import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { FaqsComponent } from './utility/faqs/faqs/faqs.component';
import { NotificationPanelComponent } from './navbar/notification-panel/notification-panel.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    CapitalizePipe,
    NavbarComponent,
    FaqsComponent,
    NotificationPanelComponent,
    // TranslatePipe

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ProgressSpinnerModule,
    ToastModule,
    SharedModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    MenuModule,
    ButtonModule,
  ],
  providers: [
    MessageService,
    provideHttpClient(
      withInterceptors([
        authenticationInterceptor,
        loaderInterceptor
      ])
    ),
    TranslateService
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }
